export interface NavLink {
  label: string;
  href: string;
}

export interface MoreNavLink {
  label: string;
  href: string;
  description: string;
  icon: string; // SVG path d attribute
  color: string; // Accent color for hover
}

export interface SocialLink {
  name: string;
  href: string;
  icon: string;
}

export const servicesDropdown: NavLink[] = [
  { label: "UI/UX Design", href: "/services#uiux" },
  { label: "Web Development", href: "/services#webdev" },
  { label: "Graphic Design", href: "/services#graphic" },
  { label: "Presentation Design", href: "/services#presentations" },
  { label: "Webflow & Framer", href: "/services#webflow-framer" },
  { label: "AI & Chatbots", href: "/services#ai" },
];

export const moreDropdown: MoreNavLink[] = [
  {
    label: "Home",
    href: "/",
    description: "Back to the beginning",
    icon: "M2.25 12l8.954-8.955c.44-.439 1.152-.439 1.591 0L21.75 12M4.5 9.75v10.125c0 .621.504 1.125 1.125 1.125H9.75v-4.875c0-.621.504-1.125 1.125-1.125h2.25c.621 0 1.125.504 1.125 1.125V21h4.125c.621 0 1.125-.504 1.125-1.125V9.75M8.25 21h8.25",
    color: "#E11D24",
  },
  {
    label: "About Us",
    href: "/about",
    description: "Our story & mission",
    icon: "M18 18.72a9.094 9.094 0 003.741-.479 3 3 0 00-4.682-2.72m.94 3.198l.001.031c0 .225-.012.447-.037.666A11.944 11.944 0 0112 21c-2.17 0-4.207-.576-5.963-1.584A6.062 6.062 0 016 18.719m12 0a5.971 5.971 0 00-.941-3.197m0 0A5.995 5.995 0 0012 12.75a5.995 5.995 0 00-5.058 2.772m0 0a3 3 0 00-4.681 2.72 8.986 8.986 0 003.74.477m.94-3.197a5.971 5.971 0 00-.94 3.197M15 6.75a3 3 0 11-6 0 3 3 0 016 0zm6 3a2.25 2.25 0 11-4.5 0 2.25 2.25 0 014.5 0zm-13.5 0a2.25 2.25 0 11-4.5 0 2.25 2.25 0 014.5 0z",
    color: "#3B82F6",
  },
  {
    label: "Our Team",
    href: "/team",
    description: "Meet the crew",
    icon: "M15 19.128a9.38 9.38 0 002.625.372 9.337 9.337 0 004.121-.952 4.125 4.125 0 00-7.533-2.493M15 19.128v-.003c0-1.113-.285-2.16-.786-3.07M15 19.128v.106A12.318 12.318 0 018.624 21c-2.331 0-4.512-.645-6.374-1.766l-.001-.109a6.375 6.375 0 0111.964-3.07M12 6.375a3.375 3.375 0 11-6.75 0 3.375 3.375 0 016.75 0zm8.25 2.25a2.625 2.625 0 11-5.25 0 2.625 2.625 0 015.25 0z",
    color: "#8B5CF6",
  },
  {
    label: "Projects",
    href: "/projects",
    description: "190+ works delivered",
    icon: "M2.25 15.75l5.159-5.159a2.25 2.25 0 013.182 0l5.159 5.159m-1.5-1.5l1.409-1.409a2.25 2.25 0 013.182 0l2.909 2.909M3.75 21h16.5a2.25 2.25 0 002.25-2.25V5.25A2.25 2.25 0 0020.25 3H3.75A2.25 2.25 0 001.5 5.25v13.5A2.25 2.25 0 003.75 21z",
    color: "#10B981",
  },
  {
    label: "Pricing",
    href: "/pricing",
    description: "Transparent plans",
    icon: "M12 6v12m-3-2.818l.879.659c1.171.879 3.07.879 4.242 0 1.172-.879 1.172-2.303 0-3.182C13.536 12.219 12.768 12 12 12c-.725 0-1.45-.22-2.003-.659-1.106-.879-1.106-2.303 0-3.182s2.9-.879 4.006 0l.415.33M21 12a9 9 0 11-18 0 9 9 0 0118 0z",
    color: "#F97316",
  },
  {
    label: "Contact",
    href: "/contact",
    description: "Let's talk",
    icon: "M21.75 6.75v10.5a2.25 2.25 0 01-2.25 2.25h-15a2.25 2.25 0 01-2.25-2.25V6.75m19.5 0A2.25 2.25 0 0019.5 4.5h-15a2.25 2.25 0 00-2.25 2.25m19.5 0v.243a2.25 2.25 0 01-1.07 1.916l-7.5 4.615a2.25 2.25 0 01-2.36 0L3.32 8.91a2.25 2.25 0 01-1.07-1.916V6.75",
    color: "#0EA5E9",
  },
];

export const socialLinks: SocialLink[] = [
  { name: "Facebook", href: "https://www.facebook.com/thedevcubix", icon: "/assets/social/Facebook.svg" },
  { name: "Instagram", href: "https://www.instagram.com/devcubix/", icon: "/assets/social/Instagram.svg" },
  { name: "LinkedIn", href: "https://www.linkedin.com/company/dev-cubix/", icon: "/assets/social/LinkedIn.svg" },
  { name: "Twitter", href: "https://twitter.com/devcubix", icon: "/assets/social/X-Twitter.svg" },
];

export const importantLinks: NavLink[] = [
  { label: "About Us", href: "/about" },
  { label: "Our Team", href: "/team" },
  { label: "Portfolio", href: "/projects" },
  { label: "Contact", href: "/contact" },
];

export const serviceLinks: NavLink[] = [
  { label: "UI/UX Design", href: "/services#uiux" },
  { label: "Web Development", href: "/services#webdev" },
  { label: "Graphic Design", href: "/services#graphic" },
  { label: "Presentation Design", href: "/services#presentations" },
  { label: "Webflow & Framer", href: "/services#webflow-framer" },
  { label: "AI & Chatbots", href: "/services#ai" },
];

export const usefulLinks: NavLink[] = [
  { label: "Contact", href: "/contact" },
  { label: "Career", href: "/contact" },
];
